<template>
    <profile-library ref="library" :profile="profile" :is-owner="true" :drawer-only="true" :refresh-external-context="refreshExternalContext" />
</template>

<script>
import ProfileLibrary from '../account/pages/ProfileLibrary.vue';

export default {
    name: 'ReviewReadingManagementDrawerHost',
    components: { ProfileLibrary },
    props: {
        profile: { type: Object, required: true },
        refreshExternalContext: { type: Function, default: null },
    },
    methods: {
        open(selection, trigger = null) {
            return this.$refs.library?.openExternalManagement(selection, trigger);
        },
    },
};
</script>
